// Fetch and Axios both receive Nest's nested exception envelopes. Never pass
// an object to Error or render it as a user-facing message.
export function apiErrorMessage(value, fallback = 'Please try again.') {
  const raw = value?.response?.data ?? value;
  const detail = raw?.message ?? raw;
  const message = detail && typeof detail === 'object' && !Array.isArray(detail)
    ? detail.message
    : detail;
  if (typeof message === 'string' && message.trim()) return message;
  if (Array.isArray(message)) {
    const text = message.filter((item) => typeof item === 'string').join(' ');
    if (text.trim()) return text;
  }
  return fallback;
}
